// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-header {
  font-size: 15px;
  font-weight: 500;
  display: flex;
  justify-content: flex-end;
  margin: 10px 10px 0 0;
}
@media (max-width: 320px) {
  .page-header {
    margin: 5px 5px 0 0;
    font-size: 14px;
  }
}
.page-header__item {
  display: inline-block;
  border-top: 3px solid rgba(0, 0, 0, 0.7);
  padding-top: 0.25rem;
  vertical-align: top;
  margin-right: 1rem;
  width: 5rem;
}
@media (max-width: 320px) {
  .page-header__item {
    width: 4rem;
    margin-right: 0.8rem;
  }
}
.page-header__item.last {
  margin-right: 0;
  width: 5.5rem;
  opacity: 0.3;
}`, "",{"version":3,"sources":["webpack://./src/Components/PageHeader/PageHeader.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,qBAAA;AACF;AACE;EAPF;IAQI,mBAAA;IACA,eAAA;EAEF;AACF;AAAE;EACE,qBAAA;EACA,wCAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AAEJ;AAAI;EARF;IASI,WAAA;IACA,oBAAA;EAGJ;AACF;AADI;EACE,eAAA;EACA,aAAA;EACA,YAAA;AAGN","sourcesContent":[".page-header {\n  font-size: 15px;\n  font-weight: 500;\n  display: flex;\n  justify-content: flex-end;\n  margin: 10px 10px 0 0;\n\n  @media (max-width: 320px) {\n    margin: 5px 5px 0 0;\n    font-size: 14px;\n  }\n\n  &__item {\n    display: inline-block;\n    border-top: 3px solid rgba(0, 0, 0, 0.7);\n    padding-top: 0.25rem;\n    vertical-align: top;\n    margin-right: 1rem;\n    width: 5rem;\n\n    @media (max-width: 320px) {\n      width: 4rem;\n      margin-right: 0.8rem;\n    }\n\n    &.last {\n      margin-right: 0;\n      width: 5.5rem;\n      opacity: 0.3;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
